import CircularGraph from "../../common/CircularGraph";
import React from "react";
import useTheme from "../../../../../common/hooks/useTheme";
import { useSelector } from "react-redux";
import { RootStatePlatform } from "../../../store/platform-slice";
import BlurContainer from "../../../../../common/ui/BlurContainer";
import { useAppStore } from "../../../../../providers/AppStore";
import ItemCardHome from "../ItemCardHome";
import DailyLog from "../DailyLog";
import { useAuth } from "../../../../../providers/AuthProvider";

const OverviewTab = () => {
  const theme = useTheme();
  const homeData = useSelector(
    (state: RootStatePlatform) => state.platform.dataNutServer
  );
  const { AuthUser, AuthIsSimpleUser } = useAuth();
  const { ASSelectedClient } = useAppStore();

  const filteredTrends = homeData.overview_tab.trends.filter(
    (el: any) => el.hidden === false
  );

  return (
    <div style={styles.container}>
      <BlurContainer
        isBlurred={
          AuthIsSimpleUser
            ? !AuthUser.has_advanced_app_access
            : !ASSelectedClient?.has_advanced_app_access
        }
        title={"Please contact your PNOE tester\n to get started"}
        text={""}
        customBorderColor={
          !AuthUser.has_advanced_app_access
            ? theme.colorTokens.W[60]
            : undefined
        }
      >
        <div style={styles.circularChartsContainer()}>
          <CircularGraph
            size={107}
            strokeWidth={4}
            value={homeData.overview_tab.scores[0].value}
            color={theme.colors_ds.PRIMARY_ICON_MAIN}
            backgroundColor={theme.colorTokens.P[10]}
            label={homeData.overview_tab.scores[0].name}
            isMediumChart={true}
          />
          <CircularGraph
            size={107}
            strokeWidth={4}
            value={homeData.overview_tab.scores[1].value}
            color={theme.colors_ds.PRIMARY_ICON_MAIN}
            backgroundColor={theme.colorTokens.P[10]}
            label={homeData.overview_tab.scores[1].name}
            isMediumChart={true}
          />
          <CircularGraph
            size={107}
            strokeWidth={4}
            value={homeData.overview_tab.scores[2].value}
            color={theme.colors_ds.PRIMARY_ICON_MAIN}
            backgroundColor={theme.colorTokens.P[10]}
            label={homeData.overview_tab.scores[2].name}
            isMediumChart={true}
          />
        </div>
        <div style={styles.title(theme)}>Trends</div>
        <div style={styles.cardsContainer}>
          {filteredTrends.map((trend: any, index: number) => (
            <ItemCardHome
              key={index}
              label={trend.title}
              value={Math.round(trend.daily_current_value)}
              maxValue={
                trend.daily_target_value
                  ? Math.round(trend.daily_target_value)
                  : undefined
              }
              //TODO: find out a way to get the unit from the backend
              unit={trend.name === 8 ? "gr" : "Kcal"}
              weeklyValue={Math.round(trend.weekly_average_value)}
            />
          ))}
        </div>
        <div style={styles.message}>
          <span style={styles.messageLabel(theme)}>Current</span>
          <span style={styles.messageConnectLabel(theme)}> vs </span>
          <span style={styles.messageDuration(theme)}>7 day average</span>
        </div>
        <DailyLog type="workout" data={homeData.overview_tab.daily_tasks} />
        <DailyLog type="nutrition" data={homeData.nutrition_tab.daily_meals} />
      </BlurContainer>
    </div>
  );
};

export default OverviewTab;

const styles = {
  container: {
    width: "100%",
  },
  circularChartsContainer: () => ({
    marginTop: "32px",
    paddingBottom: "32px",
    display: "flex",
    flexDirection: "row" as "row",
    justifyContent: "space-between",
  }),
  title: (theme: any) => ({
    marginBottom: "8px",
    alignSelf: "flex-start",
    fontFamily: "var(--font-Medium)",
    fontSize: "14px",
    color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
  }),
  cardsContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "4px",
  },
  message: { textAlign: "center" as "center", marginTop: "8px" },
  messageLabel: (theme: any) => ({
    fontFamily: "var(--font-Bold)",
    fontSize: "10px",
    color: theme.colors_ds.NEUTRAL_TEXT_WEAK,
    lineHeight: "16px",
  }),
  messageConnectLabel: (theme: any) => ({
    fontFamily: "var(--font-Medium)",
    fontSize: "10px",
    color: theme.colors_ds.NEUTRAL_TEXT_WEAK,
    lineHeight: "16px",
  }),
  messageDuration: (theme: any) => ({
    fontFamily: "var(--font-Medium)",
    fontSize: "10px",
    color: theme.colors_ds.NEUTRAL_TEXT_WEAK,
    lineHeight: "16px",
  }),
};
